import React from 'react';
import PropTypes from 'prop-types';
const sortBy = require('lodash/sortBy');
const find = require('lodash/find');
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';

const propTypes = {
    actions: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.string,
        iconStyle: PropTypes.object,
        subNavIconStyle: PropTypes.object, // specific iconStyle variant for use in SubNav (defaults to iconStyle if not present)
        iconClass: PropTypes.string,
        label: PropTypes.element,
        value: PropTypes.string.isRequired,
        tooltip: PropTypes.string,
        group: PropTypes.number
    })),
    bgColor: PropTypes.string,
    menuClasses: PropTypes.string,
    children: PropTypes.node,
    containerClassName: PropTypes.string,
    noGutters: PropTypes.bool,
};

const defaultProps = {
    actions: [],
    bgColor: null,
    menuClasses: '',
    children: null,
    containerClassName: "subnav__container",
    noGutters: false,
};

function SubNav(props) {
    function handleActionSelect(selectedKey) {
        find(props.actions, { value: selectedKey }).handler();
    }

    let extraClasses;
    if (props.noGutters) {
        extraClasses = 'subnav--no-gutters';
    }
    else {
        extraClasses = 'subnav--norow';
    }

    return (
        <nav
            className={`mzl-cs-workarea sub-navbar ${extraClasses}`}
            style={!!props.bgColor ? { backgroundColor: props.bgColor } : {}}
        >
            <div className={props.containerClassName}>
                <div className="nav-left">
                    {props.children}
                </div>
                {(props.actions.length > 0) &&
                    <div className={`nav-right ${props.menuClasses}`}>
                        <Wrapper
                            id='action-dropdown'
                            className='AriaMenuButton no-caret'
                            onSelection={handleActionSelect}
                        >
                            <Button className='AriaMenuButton-trigger AriaMenuButton-trigger--bare-text'>
                                <span className="fa fa-bars hamburger" aria-hidden={true}/>
                                <span className="sr-only">action menu</span>
                            </Button>
                            <Menu>
                                <ul className='AriaMenuButton-menu AriaMenuButton-menu--flushRight'>
                                    {sortBy(props.actions, 'group').map((action) => {
                                        let iconStyle = {};
                                        if (!!action.subNavIconStyle) {
                                            iconStyle = action.subNavIconStyle;
                                        }
                                        else if (!!action.iconStyle) {action.icon
                                            iconStyle = action.iconStyle;
                                        }

                                        return (
                                            <li className="AriaMenuButton-menuItemWrapper" key={action.value}>
                                                <MenuItem
                                                    className="AriaMenuButton-menuItem"
                                                    value={action.value}
                                                    text={action.value}
                                                >
                                                    <span className="action-item">
                                                        {(!!action.icon) &&
                                                            <img src={action.icon} className="action-icon" aria-hidden="true" style={iconStyle} />
                                                        }
                                                        {!!action.iconClass && <span className={`fa ${action.iconClass}`} aria-hidden="true" />}
                                                        {!!action.label ? action.label : action.value}
                                                        { action.child ? action.child : null }
                                                    </span>
                                                </MenuItem>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </Menu>
                        </Wrapper>
                    </div>
                }
            </div>
        </nav>
    );
}

SubNav.propTypes = propTypes;
SubNav.defaultProps = defaultProps;

export default SubNav;